const translations = {
    fieldBoundaries: 'Field Boundaries',
    noBoundariesFound: 'No boundaries found',
    otherBoundaries: 'Other Boundaries',
    search: 'Search'
};

export default translations;
